import React from 'react';
import {motion} from 'framer-motion';
import {Link} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
const {FiArrowRight} = FiIcons;

const AuthorStrip = () => (
  <section className="py-24 bg-white">
    <div className="max-w-6xl mx-auto px-6">
      <div className="grid md:grid-cols-2 gap-16 items-center">
        <motion.div
          initial={{opacity: 0, scale: 0.95}}
          whileInView={{opacity: 1, scale: 1}}
          viewport={{once: true}}
          transition={{duration: 0.8}}
          className="relative"
        >
          <div className="absolute -inset-4 bg-brand-accent/10 rounded-3xl blur-xl" />
          <img
            src="https://media-manager-c.questera.ai/greta-media/ae05bbc051fb17176d2c348bf77438a7a494626431a725f22ebe70ac4579d949c16512ea83019a888cf26e0e50680ce7/images/aW1hZ2UvanBlZw==/91ab01df2fc17bd64fc03588a793bcb6.jpg"
            alt="Andrei Ciomîrtan - Author"
            className="relative rounded-3xl w-full object-cover aspect-square shadow-2xl"
          />
          <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur rounded-2xl p-4 shadow-lg">
            <div className="font-serif font-bold text-brand-dark">Andrei Ciomîrtan</div>
            <div className="text-xs text-brand-accent font-medium mt-0.5">Author - Blogger - Good Man in Relationship</div>
          </div>
        </motion.div>

        <motion.div
          initial={{opacity: 0, x: 30}}
          whileInView={{opacity: 1, x: 0}}
          viewport={{once: true}}
          transition={{duration: 0.8, delay: 0.2}}
        >
          <span className="text-brand-accent font-semibold tracking-widest uppercase text-xs">Meet the Author</span>
          <h3 className="text-4xl font-serif font-bold text-brand-dark mt-3 mb-6 leading-tight">
            Written from the Inside Out
          </h3>
          <div className="space-y-4 text-slate-600 leading-relaxed">
            <p>
              Andrei Ciomîrtan writes from a rare vantage point — as a man who has spent years studying the inner emotional architecture of the male psyche, and he hopes to help hundreds of couples break through the walls of silence and misunderstanding.
            </p>
            <p>
              His work is grounded in empathy, lived experience, and a deep conviction that the gap between men and women is not insurmountable — it simply requires the right map.
            </p>
            <p className="font-medium text-brand-dark">
              <em>How to Love a Good Man</em> is that map.
            </p>
          </div>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 mt-8 text-brand-accent font-semibold hover:gap-4 transition-all"
          >
            Learn more about Andrei <FiArrowRight />
          </Link>
        </motion.div>
      </div>
    </div>
  </section>
);

export default AuthorStrip;